import * as React from 'react';

const SvgEmpty = (props) => (
  <svg
    width={291}
    height={250}
    viewBox="0 0 291 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M143.061 210.736C201.013 210.736 247.997 163.752 247.997 105.593C247.997 47.4332 201.013 0.450195 143.061 0.450195C85.108 0.450195 38.125 47.4332 38.125 105.593C38.125 163.752 85.108 210.736 143.061 210.736Z"
      fill="#F7F9FD"
    />
    <path
      d="M65.8642 49.917H215.093C221.095 49.917 225.647 54.4705 225.647 60.4728V155.06C225.647 161.062 221.095 165.615 215.093 165.615H65.8642C59.8619 165.615 55.3086 161.062 55.3086 155.06V60.4728C55.3086 54.4705 60.2759 49.917 65.8642 49.917Z"
      fill="url(#paint0_linear_30807_6237)"
    />
    <g filter="url(#filter0_d_30807_6237)">
      <path
        d="M197.036 60.4658L198.305 162.583C198.305 166.071 195.45 168.767 191.962 168.767H92.3817C88.8933 168.767 86.0391 165.912 86.0391 162.583V31.2896C86.0391 27.8011 88.8933 25.1055 92.3817 25.1055H164.529L197.036 60.4658Z"
        fill="url(#paint1_linear_30807_6237)"
      />
    </g>
    <path
      d="M150.579 46.5124H102.85C101.74 46.5124 100.789 45.561 100.789 44.451C100.789 43.341 101.74 42.3896 102.85 42.3896H150.579C151.689 42.3896 152.64 43.341 152.64 44.451C152.64 45.561 151.689 46.5124 150.579 46.5124Z"
      fill="#D5DDEA"
    />
    <path
      d="M121.244 57.9294H102.85C101.74 57.9294 100.789 56.978 100.789 55.868C100.789 54.758 101.74 53.8066 102.85 53.8066H121.086C122.196 53.8066 123.147 54.758 123.147 55.868C123.147 56.978 122.196 57.9294 121.244 57.9294Z"
      fill="#D5DDEA"
    />
    <path
      d="M164.535 25.1055V53.3303C164.535 57.2945 168.024 60.4658 171.988 60.4658H197.041"
      fill="#D5DDEA"
    />
    <path
      d="M183.749 82.041H166.446H162.158H103.444C102.704 82.041 101.965 82.7821 101.965 83.8195C101.965 84.7087 102.556 85.598 103.444 85.598H162.158H166.446H183.603C184.638 85.598 185.228 84.8569 185.228 83.8195C185.228 82.9302 184.638 82.041 183.749 82.041Z"
      fill="#D5DDEA"
    />
    <path
      d="M228.545 110.56V157.13C228.545 163.132 223.785 168.099 217.575 168.099H64.2079C58.2058 168.099 53.2383 163.132 53.2383 157.13V106.628"
      stroke="#1676EE"
      strokeWidth={3.61446}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.508 84.4814H167.077C162.316 84.4814 157.763 86.1372 154.244 89.0349L141.619 99.3835C138.1 102.281 133.547 103.937 128.787 103.937H74.1455C68.5572 103.937 64.0039 108.491 64.0039 114.079C64.0039 114.493 64.0039 115.114 64.2109 115.528L74.3525 168.927C75.1805 173.894 79.3198 177.62 84.4943 177.62H201.435C206.401 177.62 210.747 174.101 211.576 169.134L225.65 96.072C226.685 90.4837 222.959 85.5164 217.372 84.4814C216.543 84.4814 215.922 84.4814 215.508 84.4814Z"
      fill="white"
    />
    <g filter="url(#filter1_d_30807_6237)">
      <path
        d="M237.238 70.2002H174.318C168.109 70.2002 162.314 72.2699 157.553 76.2023L140.996 89.6556C136.442 93.3811 130.44 95.6578 124.23 95.6578H53.0315C45.7875 95.6578 39.9922 101.66 39.9922 108.697C39.9922 109.318 39.9922 109.939 40.1992 110.56L53.2385 180.311C54.2735 186.933 59.8618 191.694 66.2779 191.694H218.61C225.234 191.694 230.615 187.141 231.65 180.517L250.07 85.1023C251.313 77.8582 246.552 71.4419 239.308 69.9932C238.687 70.2002 237.858 70.2002 237.238 70.2002Z"
        fill="url(#paint2_linear_30807_6237)"
      />
    </g>
    <path
      d="M244.902 63.1941C248.86 63.1941 252.07 59.9848 252.07 56.0262C252.07 52.0675 248.86 48.8584 244.902 48.8584C240.944 48.8584 237.734 52.0675 237.734 56.0262C237.734 59.9848 240.944 63.1941 244.902 63.1941Z"
      fill="#EAEEF9"
    />
    <path
      d="M237.735 39.9426C240.438 39.9426 242.63 37.7509 242.63 35.0474C242.63 32.344 240.438 30.1523 237.735 30.1523C235.032 30.1523 232.84 32.344 232.84 35.0474C232.84 37.7509 235.032 39.9426 237.735 39.9426Z"
      fill="#EAEEF9"
    />
    <path
      d="M39.4771 56.0265C42.1806 56.0265 44.3722 53.8349 44.3722 51.1314C44.3722 48.4279 42.1806 46.2363 39.4771 46.2363C36.7736 46.2363 34.582 48.4279 34.582 51.1314C34.582 53.8349 36.7736 56.0265 39.4771 56.0265Z"
      fill="#EAEEF9"
    />
    <path
      d="M28.4659 163.719C33.4867 163.719 37.5568 159.649 37.5568 154.628C37.5568 149.607 33.4867 145.537 28.4659 145.537C23.4451 145.537 19.375 149.607 19.375 154.628C19.375 159.649 23.4451 163.719 28.4659 163.719Z"
      fill="#EAEEF9"
    />
    <path
      d="M235.138 205.345L204.729 174.997C172.632 198.602 128.625 175.588 128.625 137.063C128.625 110.845 149.995 89.6016 176.18 89.6016C214.021 89.6016 237.248 132.089 215.202 164.207L245.779 194.724C248.736 197.674 248.736 202.396 245.779 205.345C242.823 208.296 238.094 208.296 235.138 205.345ZM176.18 104.691C158.273 104.691 143.66 119.275 143.66 137.147C143.66 165.893 178.122 179.719 197.888 161.257C220.271 140.35 205.32 104.691 176.18 104.691Z"
      fill="url(#paint3_linear_30807_6237)"
    />
    <path
      d="M172.884 144.227C172.8 143.552 172.715 142.878 172.715 142.119C172.715 139.337 173.898 136.808 176.853 134.616L179.388 132.762C180.993 131.581 181.668 130.233 181.668 128.631C181.668 126.271 179.979 123.994 176.432 123.994C172.715 123.994 171.11 126.945 171.11 129.895C171.11 130.485 171.195 131.076 171.279 131.581L164.691 131.328C164.522 130.57 164.438 129.727 164.438 128.968C164.438 123.32 168.661 117.925 176.348 117.925C184.456 117.925 188.68 122.983 188.68 128.294C188.68 132.424 186.568 135.291 183.526 137.483L181.414 139C179.558 140.264 178.628 141.95 178.628 144.058V144.395H172.884V144.227ZM175.841 147.598C178.121 147.598 179.979 149.453 179.979 151.729C179.979 154.005 178.121 155.86 175.841 155.86C173.56 155.86 171.701 154.005 171.701 151.729C171.701 149.453 173.56 147.598 175.841 147.598Z"
      fill="url(#paint4_linear_30807_6237)"
    />
    <defs>
      <filter
        id="filter0_d_30807_6237"
        x={59.533}
        y={11.8525}
        width={165.278}
        height={196.673}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={13.253} />
        <feGaussianBlur stdDeviation={13.253} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_6237"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_6237"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_30807_6237"
        x={13.4862}
        y={56.7402}
        width={263.285}
        height={174.712}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={13.253} />
        <feGaussianBlur stdDeviation={13.253} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_6237"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_6237"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30807_6237"
        x1={140.492}
        y1={53.9362}
        x2={140.492}
        y2={118.877}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30807_6237"
        x1={142.135}
        y1={21.7824}
        x2={142.135}
        y2={170.315}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_30807_6237"
        x1={145.061}
        y1={67.1781}
        x2={145.061}
        y2={193.006}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_30807_6237"
        x1={188.321}
        y1={93.699}
        x2={188.321}
        y2={159.907}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#659AFF" />
        <stop offset={1} stopColor="#0F62FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_30807_6237"
        x1={176.561}
        y1={119.243}
        x2={176.561}
        y2={140.535}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#659AFF" />
        <stop offset={1} stopColor="#0F62FE" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgEmpty;
